import { defineMessages } from 'react-intl'

export default defineMessages({
    mergeCustomer: {
        id: 'containers.CustomerPage.Actions.mergeCustomer',
        defaultMessage: 'Merge customer',
    },
    actionsLabel: {
        id: 'containers.CustomerPage.Actions.actionsLabel',
        defaultMessage: 'More',
    }
})
